import {useState} from "react";
import {Fab, Menu, MenuItem} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

export const CreateFabButton = ({ onCreateSchema, onCreateNode, onCreateRelation }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCreateSchema = () => {
    handleMenuClose();
    onCreateSchema?.();
  };

  const handleCreateNode = () => {
    handleMenuClose();
    onCreateNode?.();
  };

  const handleCreateRelation = () => {
    handleMenuClose();
    onCreateRelation?.();
  };

  return (
    <>
      <Fab
        color="primary"
        aria-label="add"
        variant={"outlined"}
        onClick={handleMenuClick}
        sx={{
          position: 'absolute', bottom: 20, right: 20, zIndex: 100,
          bgcolor: "primary.light"
        }}
      >
        <AddIcon />
      </Fab>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              p: 1, borderRadius: 3,
              minWidth: "170px"
            }
          }
        }}
      >
        <MenuItem onClick={handleCreateSchema}>Create Schema</MenuItem>
        <MenuItem onClick={handleCreateNode}>Create Node</MenuItem>
        <MenuItem onClick={handleCreateRelation}>Create Relation</MenuItem>
      </Menu>
    </>
  );
};